import {Component, Input, OnInit} from '@angular/core';
import {BaseModalComponent} from "common-shared";
import {GraphService} from "../graph.service";
import {GraphOptions} from "../models/graph-options";
import {EntityTypes} from "web-shared";

@Component({
  selector: 'app-graph-options',
  templateUrl: './graph-options.component.html',
  styles: []
})
export class GraphOptionsComponent extends BaseModalComponent implements OnInit {
  allNodeTypes: { id: number, name: string }[]
  @Input() options: GraphOptions;
  saveToStorage = false;

  constructor(public graphService: GraphService) {
    super();
  }

  ngOnInit(): void {
    if(this.options == null){
      this.saveToStorage = true;
      this.options = this.graphService.getOptions();
    }

    const notNodeTypes = [EntityTypes[EntityTypes.Classificator], EntityTypes[EntityTypes.Process], EntityTypes[EntityTypes.Property]];
    this.allNodeTypes = Object.entries(EntityTypes)
      .filter(e => !isNaN(e[0] as any))
      .filter(value => !notNodeTypes.includes(value[1] as string))
      .map(e => ({name: e[1] as string, id: Number(e[0]), group: 'Select all'}));
  }

  save() {
    if(this.saveToStorage){
      this.graphService.setOptions(this.options);
    }
  }
}
